import { gql } from '@apollo/client';
import { DealFragment } from '../fragments/DealFragment';
/**
 * @const CreateDealMutation
 * @since 1.0.0
 */
export const CreateDealMutation = gql `
  mutation CreateDealMutation($input: CreateDealInput!) {
    createDeal(input: $input) {
      ...DealFragment
    }
  }

  ${DealFragment}
`;
